// components/EnterpriseCards.tsx
import Image from "next/image";

export default function EnterpriseCards() {
  const cards = [
    {
      title: "Research & Development",
      description:
        "Compare AI outputs for validation and thorough analysis. Use specialized models for code review and debugging.",
      color: "purple",
      img: "/Integra-ai/e1.png",
    },
    {
      title: "Healthcare & Legal",
      description:
        "Ensure data privacy with self-hosted deployments for compliance with patient data regulations and sensitive information handling.",
      color: "cyan",
      img: "/Integra-ai/e2.png",
    },
    {
      title: "Educational Institutions",
      description:
        "Provide department-specific access with granular usage controls and complete student privacy.",
      color: "green",
      img: "/Integra-ai/e3.png",
    },
    {
      title: "Consulting & Finance",
      description:
        "Manage client-specific model selection and allocate budgets for each project for precise billing.",
      color: "orange",
      img: "/Integra-ai/e4.png",
    },
  ];

  return (
    <section className="bg-white py-20 px-6 md:px-12">
      {/* Heading */}
      <div className="max-w-5xl mx-auto pt-10 text-center mb-16">
        <h2 className="text-3xl md:text-5xl  font-bold leading-tight bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
          Built for the Enterprise, Perfect  <br></br> for Your Team
        </h2>
        <p className="mt-6 text-base md:text-lg font-semibold text-[#7d7b7b]">
          Integra AI adapts to the unique needs of every industry whether it’s
          safeguarding sensitive healthcare data, enabling precise financial
          management, supporting academic institutions, or driving R&D
          innovation empowering teams with secure, flexible and
          enterprise-grade AI solutions.
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2  gap-20 max-w-7xl mx-auto px-10">
        {cards.map((card, idx) => (
        <div
  key={idx}
  className={`
    rounded-2xl  border-[1.5px] p-8 transform transition-all duration-500 hover:scale-105 hover:border-2
    ${card.color === "purple" ? "border-purple-200 hover:border-purple-500 bg-gradient-to-br from-purple-500/10 to-pink-500/10" : ""}
    ${card.color === "cyan" ? "border-cyan-200 hover:border-cyan-500 bg-gradient-to-br from-blue-600/10 to-cyan-600/10" : ""}
    ${card.color === "green" ? "border-green-200 hover:border-green-500 bg-gradient-to-br from-cyan-600/10 to-green-600/10" : ""}
    ${card.color === "orange" ? "border-orange-300 hover:border-orange-500 bg-gradient-to-br from-orange-500/10 to-red-600/10" : ""}
  `}
>

            {/* Icon */}
            <div
              className={`
                mb-6 flex w-fit items-center justify-start rounded-md p-2
                ${card.color === "purple" ? "bg-purple-600" : ""}
                ${card.color === "cyan" ? "bg-[#0891B2]" : ""}
                ${card.color === "green" ? "bg-green-600" : ""}
                ${card.color === "orange" ? "bg-orange-500" : ""}
              `}
            >
              <Image src={card.img} alt={card.title} width={50} height={50} />
            </div>

            {/* Title */}
            <h3
              className={`
                mb-2 text-xl font-bold leading-none
                ${card.color === "purple" ? "text-purple-600" : ""}
                ${card.color === "cyan" ? "text-cyan-700" : ""}
                ${card.color === "green" ? "text-green-600" : ""}
                ${card.color === "orange" ? "text-orange-500" : ""}
              `}
            >
              {card.title}
            </h3>

            {/* Description */}
            <p className="text-sm font-medium leading-[170%] text-[#444444]">
              {card.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
